import { isNil } from 'lodash';

export const { electron } = window;
export const inBrowser = isNil(electron);
